import { Component, input } from '@angular/core';
import { BenefitsListComponent } from '../benefits-list/benefits-list.component';
import { BenefitsListItem } from '../benefits-list/models/benefits-list-item.interface';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-benefits-list-not-covered-items',
  templateUrl: './benefits-list-not-covered-items.component.html',
  styleUrl: './benefits-list-not-covered-items.component.scss',
  imports: [BenefitsListComponent, IconComponent],
})
export class BenefitsListNotCoveredItemsComponent {
  readonly title = input<string | undefined>(`What's not covered`);
  benefitsListNotCoveredItems = input<BenefitsListItem[]>([]);
}
